import { Badge, Box, Grid, Heading, Image, Text, VStack } from '@chakra-ui/react';
import { format } from 'date-fns';
import { useState } from 'react';

export default function Coupons() {
    const [coupons, setCoupons] = useState([]);

    const formatDate = (dateString) => {
        try {
            return format(new Date(dateString), 'dd MMM yyyy');
        } catch {
            return dateString;
        }
    };

    return (
        <VStack spacing={{ base: 4, md: 6 }} align='stretch' w='full'>
            <Box mt={{ base: 5, md: 0 }} mb={3}>
                <Heading size={{ base: 'md', md: 'lg' }} color='gray.800' mb={{ base: 0, md: 2 }} textAlign={{ base: 'center', md: 'left' }}>
                    Coupons
                </Heading>
                <Text color='gray.600' fontSize={{ base: 'sm', md: 'md' }} textAlign={{ base: 'center', md: 'left' }}>
                    Your available coupons and special offers
                </Text>
            </Box>
            {coupons.length === 0 ? (
                <Box bg='white' borderRadius='2xl' p={{ base: 8, md: 12 }}border='1px' borderColor='gray.100' textAlign='center'>
                    <Text fontSize='6xl' mb={4}>
                        🎫
                    </Text>
                    <Text color='gray.500' fontSize={{ base: 'md', md: 'lg' }}>
                        No coupons available
                    </Text>
                </Box>
            ) : (
                <Grid templateColumns={{ base: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={{ base: 4, md: 6 }}>
                    {coupons.map((coupon) => (
                        <Box
                            key={coupon.id}
                            bg='white'
                            borderRadius='2xl'
                            overflow='hidden'
                            border='1px'
                            borderColor='gray.100'
                            _hover={{
                                transform: 'translateY(-4px)',
                            }}
                            transition='all 0.3s'>
                            {coupon.imageUrl && <Image src={coupon.imageUrl} alt={coupon.name} h='150px' w='full' objectFit='cover' />}
                            <Box p={{ base: 4, md: 5 }}>
                                <Badge colorScheme={coupon.isActive() ? 'pink' : 'gray'} mb={2} borderRadius='full' px={3} fontSize='xs'>
                                    {coupon.status}
                                </Badge>
                                <Heading size='sm' mb={2} color='gray.800'>
                                    {coupon.name}
                                </Heading>
                                <Text fontSize='sm' color='gray.600' mb={3} noOfLines={2}>
                                    {coupon.description}
                                </Text>
                                <Text fontSize='xs' color='gray.500'>
                                    Valid until: {formatDate(coupon.expiryDate)}
                                </Text>
                                <Text fontSize={{ base: 'md', md: 'lg' }} fontWeight='bold' color='pink.600' mt={2}>
                                    {coupon.discount}
                                </Text>
                            </Box>
                        </Box>
                    ))}
                </Grid>
            )}
        </VStack>
    );
}
